import React from 'react'
import { Button, Pane } from 'evergreen-ui'

const PrintBillReceipt = ({ DataRegister }) => {
    return (
        <div>
            <Pane display="flex" flexDirection="column" gap={5}>
                {DataRegister[0].REGISTER_STATUS_BILL_ROB1_BOOK !== null ? (
                    <Button
                        appearance="primary"
                        intent="success"
                        onClick={() => {
                            window.open(
                                "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                DataRegister[0].ROB_YEAR +
                                "&BOOK_NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROB1_BOOK.split("/")[1] +
                                "&ID_NO=" +
                                DataRegister[0].REGISTER_ID +
                                "&NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROB1_NO +
                                "&typeuser=2&countbill=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROB1_COUNT
                            );
                        }}
                    >
                        ใบเสร็จการชำระเงินงวดที่ 1
                    </Button>
                ) : null}
                {DataRegister[0].REGISTER_STATUS_BILL_ROB2_BOOK !== null ? (
                    <Button
                        appearance="primary"
                        intent="success"
                        onClick={() => {
                            window.open(
                                "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                DataRegister[0].ROB_YEAR +
                                "&BOOK_NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROB2_BOOK.split("/")[1] +
                                "&ID_NO=" +
                                DataRegister[0].REGISTER_ID +
                                "&NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROB2_NO +
                                "&typeuser=2&countbill=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROB2_COUNT
                            );
                        }}
                    >
                        ใบเสร็จการชำระเงินงวดที่ 2
                    </Button>
                ) : null}
                {DataRegister[0].REGISTER_STATUS_BILL_ROBFULL_BOOK !== null ? (
                    <Button
                        appearance="primary"
                        intent="success"
                        onClick={() => {
                            window.open(
                                "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                DataRegister[0].ROB_YEAR +
                                "&BOOK_NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROBFULL_BOOK.split("/")[1] +
                                "&ID_NO=" +
                                DataRegister[0].REGISTER_ID +
                                "&NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROBFULL_NO +
                                "&typeuser=2&countbill=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROBFULL_COUNT
                            );
                        }}
                    >
                        ใบเสร็จการชำระเงินเต็มจำนวน
                    </Button>
                ) : null}
                {DataRegister[0].REGISTER_STATUS_BILL_ROBDIFF_BOOK !== null ? (
                    <Button
                        appearance="primary"
                        intent="success"
                        onClick={() => {
                            window.open(
                                "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                DataRegister[0].ROB_YEAR +
                                "&BOOK_NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROBDIFF_BOOK.split("/")[1] +
                                "&ID_NO=" +
                                DataRegister[0].REGISTER_ID +
                                "&NO=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROBDIFF_NO +
                                "&typeuser=2&countbill=" +
                                DataRegister[0].REGISTER_STATUS_BILL_ROBDIFF_COUNT
                            );
                        }}
                    >
                        ใบเสร็จการชำระเงินส่วนต่างเพิ่มเติม
                    </Button>
                ) : null}
            </Pane>
        </div>
    )
}

export default PrintBillReceipt